export default __webpack_public_path__ + "static/media/manifestationofthesun.e97f0986.png";